var map = {
	"./david.webp": 4709,
	"./fangjingjing.webp": 7742,
	"./jake.webp": 8649,
	"./jody.webp": 6030,
	"./kevin.webp": 8422,
	"./misty.webp": 6438,
	"./sanderHe.webp": 70,
	"./starZhou.webp": 7743,
	"./tim.webp": 7219,
	"./victorLi.webp": 6478,
	"./wang.webp": 1448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6952;